import * as React from 'react';

import { Tooltip, TooltipContent, TooltipNoArrow, TooltipTrigger } from './ui/tooltip';

import { cn } from '@/lib/utils';

export const Kbd = ({ className, ...props }: React.ComponentProps<'kbd'>) => {
  return (
    <kbd
      className={cn(
        "bg-background text-muted-foreground pointer-events-none flex h-5 min-w-4 items-center justify-center gap-1 rounded border px-1 font-sans text-[0.7rem] font-medium select-none [&_svg:not([class*='size-'])]:size-3",
        className
      )}
      {...props}
    />
  );
};

interface KbdTooltipProps {
  children: React.ReactNode;
  content: string;
  shortcut: string[] | string;
  side?: 'top' | 'right' | 'bottom' | 'left';
  align?: 'start' | 'center' | 'end';
}

export const KbdTooltip = ({ children, content, shortcut, side = 'top', align = 'center' }: KbdTooltipProps) => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipNoArrow
        side={side}
        align={align}
        sideOffset={10}
        className="text-sm bg-secondary border border-border py-1 px-2 text-primary"
      >
        <span className="inline-flex cursor-help items-center gap-2">
          <span className="text-xs">{content}</span>
          <span className="flex items-center gap-1">
            {Array.isArray(shortcut) ? (
              shortcut.map((key, index) => (
                <React.Fragment key={key}>
                  <Kbd>{key}</Kbd>
                  {index < shortcut.length - 1 && <span className="text-xs text-muted-foreground">then</span>}
                </React.Fragment>
              ))
            ) : (
              <Kbd>{shortcut}</Kbd>
            )}
          </span>
        </span>
      </TooltipNoArrow>
    </Tooltip>
  );
};
